import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Estudo } from '../estudo/estudo';
import { DesclassificarDialogComponent } from './desclassificar-dialog.component';

@Component({
  templateUrl: './desclassificar-varios-button.component.html',
  selector: 'app-desclassificar-varios-button'
})
export class DesclassificarVariosButtonComponent {
  @Input()  estudos: Estudo[];
  @Input()  mostrarTexto = false;
  @Output()  desclassificarEmitido: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()  selecionarTodosEmitido: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isLoading: boolean;

  constructor(public dialog: MatDialog, private mensagem: MatSnackBar) {

  }

  public abrirDesclassificacao() {
    const dialogRef = this.dialog.open(DesclassificarDialogComponent, {
      width: '1024px',
      height: '800px',
      data: this.estudos
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      this.desclassificarEmitido.emit(result);
    });
  }

}

